import { gql, useQuery } from '@apollo/client';
import {
  GetNewslettersQuery,
  GetNewslettersQueryVariables,
} from '__generated__/queries-newsletter';
import { NEWSLETTER_FRAGMENT } from '../fragments/newsletter.newsletter.graphql';

export const GET_NEWSLETTERS_QUERY = gql`
  query GetNewsletters(
    $first: Int!
    $where: NewsletterWhereInput
    $skip: Int
    $orderBy: [NewsletterOrderByInput!]
  ) {
    newsletters(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
      ...Newsletter
    }
    newsletterCount
  }
  ${NEWSLETTER_FRAGMENT}
`;

export const useGetNewsletters = (variables: GetNewslettersQueryVariables) =>
  useQuery<GetNewslettersQuery, GetNewslettersQueryVariables>(
    GET_NEWSLETTERS_QUERY,
    {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    },
  );
